import { FunctionComponent, ReactNode } from 'react'

import BrandLogo from 'components/ui/brandLogo'
import illustration from 'assets/images/illustration-sign-in.svg'
import AuthFooter from './authFooter'
import authCss from './auth.module.scss'

/**
 * Login/sign-up layout: illustration panel on large screens, form on the right.
 * The illustration and the form share one row and are bottom-aligned, so the
 * illustration's ground line sits on the same line as the form's last row.
 */
const AuthSplitLayout: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => (
  <div className={authCss.splitPage}>
    <aside className={authCss.splitAside} aria-hidden="true">
      <BrandLogo />
    </aside>
    <div className={authCss.splitStage}>
      <div className={authCss.illustrationCell} aria-hidden="true">
        <img src={illustration} alt="" className={authCss.illustration} />
      </div>
      <div className={authCss.splitContent}>
        <div className={authCss.splitMobileBrand}>
          <BrandLogo />
        </div>
        {children}
      </div>
    </div>
    <AuthFooter className={authCss.splitFooter} />
  </div>
)

export default AuthSplitLayout
